import { AxiosResponse } from "axios";

import API from "../api";

import { Supplier, SupplierInviteParams } from "../models/supplier";

const ROUTE_NAME = "suppliers";

const SupplierService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Supplier>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Supplier[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(supplier: Supplier): Promise<AxiosResponse<Supplier>> {
    return await API.post(`/${ROUTE_NAME}`, supplier);
  },
  async update(id: number, supplier: any): Promise<AxiosResponse<Supplier>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, supplier);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async inviteToShipeezi(inviteParams: SupplierInviteParams): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/invite`, inviteParams);
  },
};

export default SupplierService;
